import { render, staticRenderFns } from "./PartnerCategorySelect.vue?vue&type=template&id=3612dd36&scoped=true"
import script from "./PartnerCategorySelect.vue?vue&type=script&lang=js"
export * from "./PartnerCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3612dd36",
  null
  
)

export default component.exports